import type { CSSObject } from '@emotion/react'
import { Color, Spacing, Typography } from '@opallabs/gem'

interface AssignmentTextProps {
  text: string
  styleOverride?: CSSObject
}

const styles: CSSObject = {
  color: Color.light.Text.Default,
  ...Typography.M500,
  display: 'flex',
  marginInlineStart: Spacing.S,
  flexGrow: 1,
  fontSize: 12,
  minInlineSize: Spacing.XS * 1.75,
  position: 'relative',
}

export const AssignmentText: React.FC<AssignmentTextProps> = ({
  text,
  styleOverride,
}) => <div css={[styles, styleOverride]}>{text}</div>
